import { render, staticRenderFns } from "./DepartmentsSelection.vue?vue&type=template&id=fd89d44a&scoped=true&"
import script from "./DepartmentsSelection.vue?vue&type=script&lang=js&"
export * from "./DepartmentsSelection.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsSelection.vue?vue&type=style&index=0&id=fd89d44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd89d44a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd89d44a')) {
      api.createRecord('fd89d44a', component.options)
    } else {
      api.reload('fd89d44a', component.options)
    }
    module.hot.accept("./DepartmentsSelection.vue?vue&type=template&id=fd89d44a&scoped=true&", function () {
      api.rerender('fd89d44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DepartmentsSelection.vue"
export default component.exports